module.exports = __webpack_public_path__ + "static/media/dm.9e975450.jpeg";